/**
 * StandaloneRoleRouter — intentionally a no-op.
 *
 * History: previously auto-redirected `/` → `/driver` whenever a
 * `mr_driver_token` was present in localStorage. The goal was to
 * recover from an old iOS bug where the wrong start_url got
 * recorded into an installed PWA.
 *
 * Problem with that approach: it caused a critical bug for users
 * who legitimately installed the storefront PWA (orange MR icon)
 * but had a driver token left in localStorage from earlier testing.
 * Tapping the storefront icon force-redirected them straight to
 * /driver — exactly opposite of their intent.
 *
 * Current architecture (per-path manifests):
 *   • Storefront install → manifest start_url `/` → lands on `/`
 *   • Driver install     → manifest start_url `/driver` → lands on
 *                          `/driver` directly
 * No JS routing is needed; the manifest does its job correctly. We
 * keep this file as an explicit no-op so the import in `App.js`
 * still resolves and to document why the auto-redirect was removed.
 */
const StandaloneRoleRouter = () => null;

export default StandaloneRoleRouter;
